interface LoadScriptOptions {
  src: string;
  id?: string;
  async?: boolean;
  defer?: boolean;
}

const loadScript = (opts: LoadScriptOptions): Promise<void> => {
  const {
    src,
    id,
    async = true,
    defer = true,
  } = opts;

  return new Promise((resolve, reject) => {
    if (id && document.getElementById(id)) {
      resolve();
      return;
    }

    const s = document.createElement('script');
    if (id) {
      s.id = id;
    }
    s.src = src;
    s.async = async;
    s.defer = defer;

    const onLoad = () => resolve();
    const onError = () => reject(new Error(`Failed to load script: ${src}`));

    s.addEventListener('load', onLoad, { once: true });
    s.addEventListener('error', onError, { once: true });

    document.head.appendChild(s);
  });
};

export const scriptLoader = () => ({
  loadScript,
});
